type NorceFailure = {
	data?: { message?: string; statusMessage?: string };
	statusMessage?: string;
	message?: string;
};

/** The message of a failed norce-pwa account call, or `fallback`. */
export const norceErrorMessage = (error: unknown, fallback: string): string => {
	const failure = error as NorceFailure | null | undefined;

	return (
		failure?.data?.message ||
		failure?.data?.statusMessage ||
		failure?.statusMessage ||
		failure?.message ||
		fallback
	);
};
